import React from 'react';

import CertifiedKnowleadge from 'assets/icons/certified-knowleadge.svg';

import * as S from './styles';

const Certified = () => (
  <S.Container>
    <S.Item>
      <S.Image
        src={CertifiedKnowleadge}
        alt="Ícone de uma medalha representando o conhecimento cerficado"
      />
      <S.ItemDescription>
        <p>
          <span>Certificado:</span> Possuo certificação de uma entidade de
          confiança. Essa opção não é contabilizada como nota.
        </p>
      </S.ItemDescription>
    </S.Item>
  </S.Container>
);

export default Certified;
